import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import acts from "@/store/modules/profile/acts";
import courses from "./modules/landing/courses";
import categories from "@/store/modules/landing/categories";
import topOrganizations from "@/store/modules/landing/topOrganizations";
import topTeachers from "@/store/modules/landing/topTeachers";
import allCourses from "@/store/modules/landing/courses";
import organizations from "@/store/modules/landing/organizations";
import vacancy from "@/store/modules/landing/vacancy";
import privateLessons from "@/store/modules/landing/privateLessons";
import reference from "@/store/modules/landing/reference";
import profileData from "@/store/modules/profile/profileData";
import children from "@/store/modules/profile/children";
import applications from "@/store/modules/profile/applications";
import exportChild from "@/store/modules/profile/exportChild";
import issuedBy from "@/store/modules/profile/issuedBy";
import documentType from "@/store/modules/profile/documentType";
import sportCourses from "@/store/modules/landing/sportCourses";
import cultureCourses from "@/store/modules/landing/cultureCourses";
import favorites from './modules/landing/favorites'
import aboutInfo from './modules/landing/aboutInfo'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    acts,
    courses,
    vacancy,
    issuedBy,
    children,
    reference,
    allCourses,
    categories,
    exportChild,
    profileData,
    topTeachers,
    documentType,
    applications,
    organizations,
    privateLessons,
    topOrganizations,
    sportCourses,
    cultureCourses,
    favorites,
    aboutInfo
  },
});
